<button
  (click)="voltarParaHome()"
  aria-label="Voltar para a página inicial">
  <img src="/assets/icons/home.svg" alt="Ícone de uma Casa">
  Home
</button>
